import { render, staticRenderFns } from "./plazoFijo.vue?vue&type=template&id=ace67b8e&scoped=true"
import script from "./plazoFijo.vue?vue&type=script&lang=js"
export * from "./plazoFijo.vue?vue&type=script&lang=js"
import style0 from "./plazoFijo.vue?vue&type=style&index=0&id=ace67b8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace67b8e",
  null
  
)

export default component.exports